/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0CalendareventCreateUpdateCalendarEventPost } from '../fn/calendar-event/api-v-0-calendarevent-create-update-calendar-event-post';
import { ApiV0CalendareventCreateUpdateCalendarEventPost$Params } from '../fn/calendar-event/api-v-0-calendarevent-create-update-calendar-event-post';
import { apiV0CalendareventDeleteCalendarEventDelete } from '../fn/calendar-event/api-v-0-calendarevent-delete-calendar-event-delete';
import { ApiV0CalendareventDeleteCalendarEventDelete$Params } from '../fn/calendar-event/api-v-0-calendarevent-delete-calendar-event-delete';
import { apiV0CalendareventGetAllCalendarEventsGet$Json } from '../fn/calendar-event/api-v-0-calendarevent-get-all-calendar-events-get-json';
import { ApiV0CalendareventGetAllCalendarEventsGet$Json$Params } from '../fn/calendar-event/api-v-0-calendarevent-get-all-calendar-events-get-json';
import { apiV0CalendareventGetAllCalendarEventsGet$Plain } from '../fn/calendar-event/api-v-0-calendarevent-get-all-calendar-events-get-plain';
import { ApiV0CalendareventGetAllCalendarEventsGet$Plain$Params } from '../fn/calendar-event/api-v-0-calendarevent-get-all-calendar-events-get-plain';
import { CalendarEvent } from '../models/calendar-event';

@Injectable({ providedIn: 'root' })
export class CalendarEventService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0CalendareventGetAllCalendarEventsGet()` */
  static readonly ApiV0CalendareventGetAllCalendarEventsGetPath = '/api/v0/calendarevent/getAllCalendarEvents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CalendareventGetAllCalendarEventsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CalendareventGetAllCalendarEventsGet$Plain$Response(params?: ApiV0CalendareventGetAllCalendarEventsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CalendarEvent>>> {
    const obs = apiV0CalendareventGetAllCalendarEventsGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CalendareventGetAllCalendarEventsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CalendareventGetAllCalendarEventsGet$Plain(params?: ApiV0CalendareventGetAllCalendarEventsGet$Plain$Params, context?: HttpContext): Observable<Array<CalendarEvent>> {
    const resp = this.apiV0CalendareventGetAllCalendarEventsGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<CalendarEvent>>): Array<CalendarEvent> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CalendareventGetAllCalendarEventsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CalendareventGetAllCalendarEventsGet$Json$Response(params?: ApiV0CalendareventGetAllCalendarEventsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CalendarEvent>>> {
    const obs = apiV0CalendareventGetAllCalendarEventsGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CalendareventGetAllCalendarEventsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CalendareventGetAllCalendarEventsGet$Json(params?: ApiV0CalendareventGetAllCalendarEventsGet$Json$Params, context?: HttpContext): Observable<Array<CalendarEvent>> {
    const resp = this.apiV0CalendareventGetAllCalendarEventsGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<CalendarEvent>>): Array<CalendarEvent> => r.body)
    );
  }

  /** Path part for operation `apiV0CalendareventCreateUpdateCalendarEventPost()` */
  static readonly ApiV0CalendareventCreateUpdateCalendarEventPostPath = '/api/v0/calendarevent/createUpdateCalendarEvent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CalendareventCreateUpdateCalendarEventPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0CalendareventCreateUpdateCalendarEventPost$Response(params?: ApiV0CalendareventCreateUpdateCalendarEventPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0CalendareventCreateUpdateCalendarEventPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CalendareventCreateUpdateCalendarEventPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0CalendareventCreateUpdateCalendarEventPost(params?: ApiV0CalendareventCreateUpdateCalendarEventPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0CalendareventCreateUpdateCalendarEventPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0CalendareventDeleteCalendarEventDelete()` */
  static readonly ApiV0CalendareventDeleteCalendarEventDeletePath = '/api/v0/calendarevent/deleteCalendarEvent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CalendareventDeleteCalendarEventDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CalendareventDeleteCalendarEventDelete$Response(params?: ApiV0CalendareventDeleteCalendarEventDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0CalendareventDeleteCalendarEventDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CalendareventDeleteCalendarEventDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CalendareventDeleteCalendarEventDelete(params?: ApiV0CalendareventDeleteCalendarEventDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0CalendareventDeleteCalendarEventDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
